import Services from './base-services'

const service = new Services('accessHistory')

export default {
    setLogout(data: any) {
        return service.post('setLogout', data)
    },
}
